function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-testid": "iconSvg",
    focusable: "false",
    height: "30px",
    viewBox: "0 0 24 24",
    width: "30px",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "inline-block",
      verticalAlign: "middle"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-testid": "iconPath",
    fillRule: "evenodd",
    d: "M3.353 19.442L20.46 2.336l1.57 1.57L4.925 21.012l-1.57-1.57zm2.924-8.554c2.357 0 4.276-1.992 4.276-4.444C10.553 3.994 8.634 2 6.277 2 3.919 2 2 3.993 2 6.444c0 2.45 1.92 4.444 4.277 4.444zm0-6.666c1.18 0 2.138.998 2.138 2.222 0 1.226-.958 2.222-2.138 2.222S4.138 7.67 4.138 6.444c0-1.224.958-2.222 2.139-2.222zm10.691 8.89c-2.357 0-4.277 1.992-4.277 4.444 0 2.45 1.92 4.444 4.277 4.444 2.358 0 4.277-1.993 4.277-4.444 0-2.452-1.92-4.445-4.277-4.445zm0 6.666c-1.18 0-2.138-.997-2.138-2.222s.958-2.223 2.138-2.223 2.138.998 2.138 2.223c0 1.225-.958 2.222-2.138 2.222z",
    style: {
      fill: "currentcolor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.efbc632d412b7dccf1fd86ad572bf4c2.svg";
export { ForwardRef as ReactComponent };